// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3sE-2","author":"Table_author__1u4hz","authorImage":"Table_authorImage__xRc07","unreadRow":"Table_unreadRow__1L2xr"};